module.exports = __webpack_public_path__ + "img/fk.077dd862.png";